export default __webpack_public_path__ + "static/media/poppins-v15-latin-regular.c14093ce.woff";